import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useHistory, Link } from "react-router-dom";
import BrandingHeader from "../components/BrandingHeader";
import ProgressBar from "../components/ProgressBar";
import { db, storage, createdAt } from "../firebase";
import { ToastContainer, toast } from "react-toastify";
import { CountryDropdown } from "react-country-region-selector";
import { toTitleCase } from "../utils";

export default function Setup() {
  const { currentUser } = useAuth();
  const history = useHistory();
  const [file, setFile] = useState("");
  const [loading, setLoading] = useState();
  const [progress, setProgress] = useState(0);
  const [spinner, setSpinner] = useState(false);
  const [url, setUrl] = useState(null);
  const [country, setCountry] = useState("");

  let temp = JSON.parse(sessionStorage.getItem("isRegistered"));

  useEffect(() => {
    if (currentUser.displayName !== null && currentUser.emailVerfied) {
      history.push("/member/dashboard");
    } else {
      history.push("/member/setup");
    }
  }, [history, currentUser, temp.registered]);

  const types = ["image/png", "image/jpeg"];

  const handleChange = async (e) => {
    let file = e.target.files[0];

    if (file.size > 2097152) {
      toast.error("File size too big, Max file size is 2MB");
    } else if (file && types.includes(file.type)) {
      setFile(file);
      setLoading(true);
      let storageRef = storage.ref(`member/${file.name}`).put(file);
      storageRef.on(
        "state_changed",
        (snap) => {
          let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
          setProgress(percentage);
        },
        (error) => {
          console.log(error);
        },
        async () => {
          let url = await storage
            .ref("member")
            .child(file.name)
            .getDownloadURL();
          setUrl(url);
          setLoading(false);
        }
      );
    } else {
      setFile(null);
      toast.error("Please select an image file (png or jpeg)");
    }
  };

  const selectCountry = (val) => {
    setCountry(val);
  };

  async function onSubmit(e) {
    e.preventDefault();
    setSpinner(true);

    let name = e.target.name.value;
    const bio = e.target.bio.value;
    const linkedin = e.target.linkedin.value;

    name = await toTitleCase(name);

    temp.registered = true;

    if (linkedin === "https://linkedin.com/") {
      toast.warning("Please check your Linkedin profile url");
    } else if (
      linkedin.match(
        /((https?:\/\/)?((www|\w\w)\.)?linkedin\.com\/)((([\w]{2,3})?)|([^/]+\/(([\w|\d-&#?=])+\/?){1,}))$/gm
      )
    ) {
      try {
        await db.collection("registered").doc(currentUser.uid).set({
          user: true,
        });
        await db.collection("users").doc(currentUser.uid).set({
          name: name,
          linkedin: linkedin,
          email: currentUser.email,
          bio: bio,
          country: country,
          avatar: url,
          createdAt: createdAt,
        });
        currentUser.updateProfile({
          displayName: name,
          photoURL: url,
        });
        sendEmail(currentUser.email, name);
        let isRegistered = {
          registered: true,
        };
        sessionStorage.setItem("isRegistered", JSON.stringify(isRegistered));
        history.push("/member/dashboard");
        setSpinner(false);
      } catch {
        toast.warn("Please fill all the details");
        setSpinner(false);
      }
      setLoading(false);
      setSpinner(false);
    } else {
      toast.error("Linkedin url is invalid");
      setSpinner(false);
    }
  }

  async function sendEmail(myEmail, myName) {
    await fetch(
      "http://devcolony-env.eba-gse8qppb.us-west-2.elasticbeanstalk.com/sendmail/",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          email: myEmail,
          name: myName,
        }),
      }
    );
  }

  return (
    <div>
      <BrandingHeader />
      <div className="container mx-auto px-4 sm:px-2">
        <div className="mx-auto sm:w-2/4">
          <h1 className="text-2xl p-4 sm:p-5 sm:text-3xl font-semibold py-12 sm:py-4 sm:mt-8 ">
            <span className="font-semibold text-gray-600">Hi,</span>{" "}
            {currentUser.displayName
              ? currentUser.displayName
              : currentUser.email.split("@")[0]}
            <p className="font-medium text-lg sm:text-xl mt-4 text-gray-700">
              Let's get you started in this community.
            </p>
          </h1>
        </div>
        <div>
          <div className="mx-auto sm:w-1/2">
            <div className="md:grid md:grid-cols-1 ">
              <form onSubmit={onSubmit}>
                <div className="sm:rounded-md sm:overflow-hidden">
                  <div className="px-4 bg-white space-y-6 sm:p-6">
                    <div class="grid grid-cols-1 space-y-2">
                      <label class="block text-sm font-medium text-gray-700">
                        Profile photo
                      </label>
                      <div class="flex items-center justify-center w-full">
                        <label class="flex flex-col rounded-lg border-4 border-dashed w-full h-60 p-10 group text-center">
                          <div class=" w-full text-center flex flex-col items-center justify-center items-center  ">
                            {!file && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-8 sm:w-10 h-10 mt-8 text-blue-400 mb-2 group-hover:text-blue-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                />
                              </svg>
                            )}
                            <div className="w-full">
                              {file && (
                                <ProgressBar progress={progress} url={url} />
                              )}
                            </div>

                            <div class="flex flex-auto h-max  mx-auto ">
                              {file && (
                                <img
                                  class="has-mask h-16 sm:h-40 object-center rounded-lg"
                                  src={!url ? "" : url}
                                  alt=""
                                />
                              )}
                            </div>
                            {!file && (
                              <p class="pointer-none text-gray-500 ">
                                <span>Drag and drop</span> files here <br /> or{" "}
                                select a file from your computer
                              </p>
                            )}
                          </div>
                          <input
                            type="file"
                            class="hidden"
                            id="file-upload"
                            name="file-upload"
                            className="sr-only"
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                      {!file && (
                        <p class="text-sm text-gray-500">
                          <span>
                            File type: png, jpeg only and must be less than 2 mb
                          </span>
                        </p>
                      )}
                      <span>
                        {file && (
                          <div className="ml-2 truncate hidden md:inline">
                            {file.name}
                          </div>
                        )}
                      </span>
                    </div>

                    <div class="flex flex-col mb-4">
                      <label
                        for="name"
                        class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                      >
                        Name
                      </label>

                      <div class="relative">
                        <div class="absolute flex border border-transparent left-0 top-0 h-full w-10">
                          <div class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-gray-600 text-lg h-full w-full">
                            <svg
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              stroke="currentColor"
                              stroke-width="2"
                              fill="none"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="h-5 w-5"
                            >
                              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                              <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                          </div>
                        </div>

                        <input
                          type="text"
                          name="name"
                          id="name"
                          autoComplete="given-name"
                          placeholder="what should we call you?"
                          className="
                          pl-12
                      block
                      w-full
                      px-5
                      py-2.5
                      text-base
                      placeholder-gray-300
                      transition
                      duration-500
                      ease-in-out
                      transform
                      border border-transparent
                      rounded-lg
                      text-neutral-600
                      bg-gray-100
                      focus:outline-none
                      focus:border-transparent
                      focus:ring-2
                      focus:ring-white
                      focus:ring-offset-2
                      focus:ring-offset-gray-300
                    "
                          required
                        />
                      </div>
                    </div>

                    <div class="flex flex-col mb-4">
                      <label
                        for="name"
                        class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                      >
                        Linkedin Profile
                      </label>

                      <div class="relative">
                        <div class="absolute flex border border-transparent left-0 top-0 h-full w-10">
                          <div class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-gray-600 text-lg h-full w-full">
                            <svg
                              viewBox="0 0 24 24"
                              className="w-4 h-4"
                              xmlns="http://www.w3.org/2000/svg"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="h-5 w-5"
                              fill="currentColor"
                            >
                              <path d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z" />
                              <path d="m.396 7.977h4.976v16.023h-4.976z" />
                              <path d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z" />
                            </svg>
                          </div>
                        </div>

                        <input
                          type="text"
                          name="linkedin"
                          id="linkedin"
                          autoComplete="link"
                          placeholder="https://linkedin.com/in/your"
                          className="
                          pl-12
                      block
                      w-full
                      px-5
                      py-2.5
                      text-base
                      placeholder-gray-300
                      transition
                      duration-500
                      ease-in-out
                      transform
                      border border-transparent
                      rounded-lg
                      text-neutral-600
                      bg-gray-100
                      focus:outline-none
                      focus:border-transparent
                      focus:ring-2
                      focus:ring-white
                      focus:ring-offset-2
                      focus:ring-offset-gray-300
                    "
                          required
                        />
                      </div>
                    </div>

                    <div class="flex flex-col mb-4">
                      <label
                        for="name"
                        class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                      >
                        About you
                      </label>
                      <textarea
                        type="text"
                        name="bio"
                        id="bio"
                        placeholder="tell us something about yourself"
                        maxlength="200"
                        className="
                    block
                    w-full
                    px-5
                    py-2.5
                    text-base
                    placeholder-gray-300
                    transition
                    duration-500
                    ease-in-out
                    transform
                    border border-transparent
                    rounded-lg
                    text-neutral-600
                    bg-gray-100
                    focus:outline-none
                    focus:border-transparent
                    focus:ring-2
                    focus:ring-white
                    focus:ring-offset-2
                    focus:ring-offset-gray-300
                  "
                      />
                      <p class="text-sm text-gray-300 mt-2">
                        <span>Max character: 200</span>
                      </p>
                    </div>

                    <CountryDropdown
                      onChange={selectCountry}
                      value={country}
                      onInvalid={() => toast.error("country is required")}
                      className="
                      mt-1
                      block
                      w-full
                      px-5
                      py-2.5
                      text-base
                      placeholder-gray-300
                      transition
                      duration-500
                      ease-in-out
                      transform
                      border border-transparent
                      rounded-lg
                      text-neutral-600
                      bg-gray-100
                      focus:outline-none
                      focus:border-transparent
                      focus:ring-2
                      focus:ring-white
                      focus:ring-offset-2
                      focus:ring-offset-gray-300
                    "
                      required
                    />

                    <div className="flex items-start justify-between mt-4">
                      <div className="flex items-start">
                        <input
                          id="remember_me"
                          name="remember_me"
                          type="checkbox"
                          className="h-4 w-4 text-blue-600  border-gray-300 rounded"
                          required
                          autofocus
                        />
                        <label className="ml-2 block text-sm text-gray-900 ">
                          I have read and accept the{" "}
                          <Link to="/terms-condition">
                            {" "}
                            <span className="text-blue-700">
                              Terms & conditions
                            </span>
                          </Link>
                        </label>
                      </div>

                      <div className="text-sm"></div>
                    </div>
                  </div>
                  <div className="px-4 py-12 text-right sm:px-6">
                    <button
                      type="submit"
                      className="inline-flex justify-center py-3 px-8 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gradient-to-r from-blue-500 to-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      disabled={loading}
                    >
                      Continue
                      {spinner && (
                        <div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-300 h-5 w-5 ml-4"></div>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
